export default __webpack_public_path__ + "static/media/img_slide_04.3d387556.jpg";